<search-dialog-page [model]="model" (onAction)="action($event)">
  <div class="container-fluid">
    <ep-row class="col-12">
      <form #auroraSubmitForm="ngForm"
        (ngSubmit)="dsCollection.refresh(); model.dirty = false"
        (keypress)="model.dirty = true"
        style="width: 100%; margin-bottom: 0px; margin-top: 0px"
      >
        <ep-row>
          <div class="col-12 col-lg-4">
            <div class="unity-form-group" style="display: inline-block">
              <label for="Entity_Name">Entity Name</label>
              <input
                myFocus
                type="text"
                name="Entity_Name"
                [(ngModel)]="dsCollection.criteria.Entity_Name"
                ngControl="Entity_Name"
                (valueChange)="model.dirty = true"
              />
            </div>
          </div>
          <div class="col-12 col-lg-4">
            <div class="unity-form-group" style="display: inline-block">
              <label for="Entity_Quick_Search">Quick Search</label>
              <input
                type="text"
                name="Entity_Quick_Search"
                [(ngModel)]="dsCollection.criteria.Entity_Quick_Search"
                ngControl="Entity_Quick_Search"
              />
            </div>
          </div>

          <div class="col-12 col-lg-4">
            <aurora-button
              class="pull-right margin-l-5"
              style="margin-top: 16px"
              type="submit"
              [loading]="dsCollection && dsCollection.status == 'Loading'"
              variant="primary"
              (click)="auroraSubmitForm.onSubmit($event)"
            >
              Search
            </aurora-button>
            <aurora-button
              class="pull-right margin-l-5"
              style="margin-top: 16px"
              type="button"
              (click)="
                dsCollection.criteria.Entity_Name = '';
                dsCollection.criteria.Entity_Quick_Search = '';
                model.dirty = true
              "
              variant="secondary"
            >
              Reset
            </aurora-button>
          </div>
        </ep-row>
      </form>
    </ep-row>

    <ep-row>
      <div
        class="col-12"
        style="margin: 5px 5px 5px 5px; border-top: solid 1px; padding-top: 5px; border-top-color: #e5e3e3"
      >
        <ep-filter-input
          #thirdPartyFilter
          style="margin-bottom: 5px"
          [filter]="{ filterKey: '[GLOBAL]', maxDepth: 5 }"
        ></ep-filter-input>
        <span>
          <aurora-button
            type="button"
            (click)="
              select({
                Entity_Name: dsCollection.criteria.Entity_Name,
                Org_Entity_Name: dsCollection.criteria.Entity_Name,
                Entity_ID: '-1'
              })
            "
            style="float: right"
            variant="tertiary"
          >
            New Third Party
          </aurora-button>
        </span>

        <ep-max-row-warning [datasource]="dsCollection"></ep-max-row-warning>

        <div
          class="table-responsive"
          style="max-height: 400px; min-height: 400px; overflow-y: scroll; margin-top: 5px; border: 1px solid silver"
        >
          <table class="table table-select table-fixed-header">
            <tr>
              <th>Entity Name</th>
              <th>Entity ID</th>
              <th>Alternate Reference</th>
            </tr>
            <tr
              *ngFor="
                let thirdParty of dsCollection.objectNodes
                  | epFilter : thirdPartyFilter.filter : thirdPartyFilter.filter.filterText
              "
              (click)="app.getSelectedText() && select(thirdParty)"
            >
              <td>
                {{ thirdParty.Entity_Name }}
              </td>
              <td>
                {{ thirdParty.Entity_ID }}
              </td>
              <td>
                {{ thirdParty.Search_Ref }}
              </td>
            </tr>

            <tr
              class="col-12"
              *ngIf="
                !(dsCollection.objectNodes && dsCollection.objectNodes.length > 0) && dsCollection.status == 'Ready'
              "
            >
              <td>
                <span style="text-align: center"><i>No Third Parties</i></span>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </ep-row>
  </div>
</search-dialog-page>
